import React from 'react'
import { withRouter } from 'react-router-dom'
import { fetchData } from '../../API/ApiRequest.js'
import './CCAVResponseHandler.css'
import { ccavAccessCode, ccavWorkingKey, ccavencrypt, ccavdecrypt, firebase } from '../../global'
const db = firebase.firestore()
class CCAVResponseHandler extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isPaymentSuccess: false,
      orderNo: '',
      referenceNo: ''
    }
  }

  // to send email to user and head office/branch after successfull payment
  sendMail (objData, objType) {
    let reqRouteUser
    let reqRouteHO
    let reqRouteRecipient

    // Online Service Booking.
    if (objType === 'BOOKING') {
      reqRouteUser = 'ATOnlineServiceBookingToUser'
      reqRouteHO = 'ATOnlineServiceBookingToHO'
    } else if (objType === 'MEMBERSHIP') {
      if (objData['Membership Type'] === 'Gift') reqRouteUser = 'ATMembershipCardToUser'
      else reqRouteUser = 'ATMembershipCardToUserSelf'
      reqRouteRecipient = 'ATMembershipCardToRecipient'
      reqRouteHO = 'ATMembershipCardToHO'
    } else if (objType === 'GIFT') {
      reqRouteUser = 'ATOnlineGiftToUser'
      reqRouteRecipient = 'ATOnlineGiftToRecipient'
      reqRouteHO = 'ATOnlineGiftToHO'
    }

    // User mail
    fetchData(objData, reqRouteUser).then(response => {
      if (response.message === 'SUCCESS') {
        // console.log('User mail sent')
        // Head office/Branch mail
        fetchData(objData, reqRouteHO).then(response => {
          if (response.message === 'SUCCESS') {
            // console.log('HO mail sent')
            // Recipient mail
            if (objType === 'GIFT' || (objType === 'MEMBERSHIP' && objData['Membership Type'] === 'Gift')) {
              fetchData(objData, reqRouteRecipient).then(response => {
                if (response.message === 'SUCCESS') {
                  // console.log('Recipient mail sent')
                  this.setState({ isPaymentSuccess: true })
                } else console.log('Recipient mail Failure')
              })
            } else this.setState({ isPaymentSuccess: true })
          } else console.log('HO mail Failure')
        })
      } else console.log('User mail Failure')
    })
    localStorage.removeItem('orderDetail')
    localStorage.removeItem('orderDetailType')
  }

  // to get ccavenue response.
  getccavenueResponse (objMailData) {
    const mailType = localStorage.getItem('orderDetailType')
    console.log(objMailData, objMailData['Order Id'])
    const reqRouteUser = '/getTrack'
    const queryParam = '|' + objMailData['Order Id'] + '|'
    const url = 'https://api.ccavenue.com/apis/servlet/DoWebTrans?command=orderStatusTracker&access_code=' + ccavAccessCode + '&enc_request=' + ccavencrypt(queryParam, ccavWorkingKey) + '&request_type=STRING&response_type=JSON&version=1.1'
    const objData = { url: url }
    fetchData(objData, reqRouteUser).then(response => {
      console.log(response)
      console.log(response.data)
      if (response.data.status === '0') {
        const responseData = JSON.parse(ccavdecrypt(response.data.enc_response, ccavWorkingKey))
        this.setState({ orderNo: responseData.order_no, referenceNo: responseData.reference_no })
        // to send email after payment successful.
        if (objMailData) {
          // adding entry to database for all type of payment response
          db.collection('payment').doc(objMailData['Order Id']).update({
            status: response.data.status,
            order_status: responseData.order_status,
            reference_no: responseData.reference_no ? responseData.reference_no : '',
            order_date_time: responseData.order_date_time && responseData.order_date_time,
            payment_details: responseData
          })
            .then((docRef) => {
              console.log('Document updated with ID')
              // send email only if the payment is successfull
              if (responseData.order_status === 'Successful' || responseData.order_status === 'Success') {
                this.sendMail(objMailData, mailType)
              } else if (responseData.order_status === 'Unsuccessful') {
                this.props.history.push('/ccavErrorHandler')
              } else if (responseData.order_status === 'Awaited') {
                this.props.history.push('/awaited')
              } else {
                this.props.history.push('/ccavErrorHandler')
              }
            })
            .catch((error) => {
              console.error('Error adding document: ', error)
            })
        }
      } else {
        console.log('Payment Error')
        db.collection('payment').doc(objMailData['Order Id']).update({
          status: response.data.status,
          error_code: response.data.enc_error_code,
          error_desc: response.data.enc_response
        })
          .then((docRef) => {
            console.log('Document updated with ID')
            this.props.history.push('/ccavErrorHandler')
          })
          .catch((error) => {
            console.error('Error adding document: ', error)
          })
      }
    })
  }

  componentDidMount () {
    const mailData = JSON.parse(window.localStorage.getItem('orderDetail'))
    console.log(mailData, mailData['Order Id'])
    if (mailData) this.getccavenueResponse(mailData)
    else this.props.history.push('/')
    // let responseData = JSON.parse(ccavdecrypt('1816a28885460a0fdc256dbfcd4c9f12552f190e5572332215bba896efc83a2deb6990472ddcef043123863f49a871347f0fc2a707841258d099cbf3ef21ad3b06cd529e7929837448f48ecba86183a009c2201a38c6cb6b608866ebe7356c3dcb7cda3e34be2a26cd930cb97db9f8306f9d8f4cf479a0f34914e01a175662fdbc9a42d663262f25c2640c57f81ed30a09bfa58e4b40234414efd5a20e2eaa60510d993ae9f06ed6c274af690bab9c8b708e6859cad3da8e9357219dbbfd2edb44ff3e8d4803a84fd2212d292318c329a31209e91fc4c47b16be41f825eb4058b5035c533e9d0a0d68705ccbb6c14c69a968b4bf022c7b4dfd3b9d6ca084fc5a5083e7cc1b3f2c17113016c34edecf14bf4094ec9c2a4d86749a99b0ba71096e2f699852eb50bdc715e138fefe08eaf872bb4a47e01630d992f07ba1bafbe1e8b322a49c6032b510d809d95e6d52e96026e1e13672eccc78b6ea4b1121443841e0c283b7b70a99e21eb08c69e0fa8f7e1e10ddf7f41aa3aab64fe5eeb361bd7305094a34271025d09355054dfa28b2dcb219d887f1f514e2f382e2a9b74fb9fe4759d848ae977119684d621e6a3433e1482bfd7e33f9fcff4ca0cdb5a2957efef3fee44a8d0df7520769a2d8bad7b5e5f344b55916bbca9088efc21d93fc40a8f705b09cb6b65544e7808d5846fe61014b1022c6c11e7957ec5807151a510957f41d07d314e71cf9f7dd66d4d5e87c0c6207ef5af48ed6a02ca38b0a06b100a25c14170cb8ceec75c9d4780f5e729f1fd6cbc9f6cd410075a4dc440ea1a8e4ede27a19954b072951da0724d5b59cde31189b8cf9fe60f4f3700c0f968c4e0fce092ab5a3ffa02a6af1a2e738484da2bd619325842f6f38fd2d8fb7b1962704cb97170813a00e32491613050862fb5b4214ed65e7c9abe4dae412b06aca538649c8c851fa653b22edc52126d595cd768256e7d33ee662a4746ed3175c0822982bd4bf4105f1ff2fb2d3ed728e8f660e010cf8726742a187ad84b22024f02c67d7e3e5ac12901b9301df6f05898df77392b67f5ef678619a0b2c8ce7d189e9fd25398fda6f832e8e3c98b919248955628c4facf214c2f1eafde68a66321b1c35d5a35116d1c143cbef3e3a1182de11c831dd6435eee6d52bd3786581aa7d0f41032b890c0b7bb857e09fb0c6d95b3ce0afc6537c942f83f197eb9228b4a7844ecffdb4a60baa9e787824cc9c9268c50b9e6f49030e9ada4402f8fb1f6df5bbe733ce0c0d2bb129bda10e339b08022b62fe84bcea0e95d0b96e9053c68e8e8bbde4059f892515b649e1808205f82996ab7f2bf1df424c6dd901f9b47f8e15c36a2dce7aaa666899e77c6250389c8da9a2189f4f09699abe8b4abc5f3912a6f67fbd9c0a7fcc064fe85043f0c20ca9f0add4558a60c2eed562f73716b13f5e150a5337c61e10535fb2e56a74b319c752342d5ca0f426d98764a3e9c9747f86dafe1e8cd605a7537fa0a0992e53d7f69100635eab173fdbb24af45169f3dbac56223fbacbbea4bb11ebe91f70ae02aea2fff1679d1900d177f8d64387635765b83943e7238b64b2889b2587a91c9aeaf76de0efd1ba3e1f5d218ae6a27cb4413bde41', ccavWorkingKey))

    // console.log(responseData)
  }

  render () {
    return (
      <div id='ccav-block'>
        {this.state.isPaymentSuccess ? (
          <div className='ccav-box'>
            <div className='ic-ccav-success' />
            <div className='ccav-succ-title'>Thank you for your order!</div>
            <div className='ccav-succ-sub-title'>The order confirmation email with details of your order has been sent to your email address.</div>
            <div className='ccav-ref-block'>
              <div className='ccav-order-title'>Your order is <span>{this.state.orderNo}</span></div>
              <div className='ccav-divider' />
              <div className='ccav-ref-title'>Your reference id <span>{this.state.referenceNo}</span></div>
            </div>
            <div className='ccav-go-back'>Please go back to <a href='/'>Home</a></div>
          </div>
        ) : (
          <div className='ccav-loader-box'>
            <img className='ccav-loader' src='/assets/images/ccavenue-loader.gif' alt='loader' />
            <div className='ccav-loader-title'>Processing payment. Please wait...</div>
          </div>
        )}
      </div>
    )
  }
}

export default withRouter(CCAVResponseHandler)
// Dont delete this code
// merchant_id=92471&order_id=12345&currency=INR&amount=1.00&redirect_url=http%3A%2F%2Flocalhost%2FccavResponseHandler&cancel_url=http%3A%2F%2Flocalhost%2FccavResponseHandler&language=EN&billing_name=Peter&billing_address=Santacruz&billing_city=Mumbai&billing_state=MH&billing_zip=400054&billing_country=India&billing_tel=9876543210&billing_email=testing%40domain.com&delivery_name=Sam&delivery_address=Vile+Parle&delivery_city=Mumbai&delivery_state=Maharashtra&delivery_zip=400038&delivery_country=India&delivery_tel=0123456789&merchant_param1=additional+Info.&merchant_param2=additional+Info.&merchant_param3=additional+Info.&merchant_param4=additional+Info.&merchant_param5=additional+Info.&promo_code=&customer_identifier=

// Sample data to pass into ccavenue
// merchant_id=92471&
// order_id=12345&
// currency=INR&
// amount=1.00&
// redirect_url=http%3A%2F%2Flocalhost%2FccavResponseHandler&
// cancel_url=http%3A%2F%2Flocalhost%2FccavResponseHandler&
// language=EN&
// billing_name=Peter&
// billing_address=Santacruz&
// billing_city=Mumbai&
// billing_state=MH&
// billing_zip=400054&
// billing_country=India&
// billing_tel=9876543210&
// billing_email=testing%40domain.com&
// delivery_name=Sam&
// delivery_address=Vile+Parle&
// delivery_city=Mumbai&
// delivery_state=Maharashtra&
// delivery_zip=400038&
// delivery_country=India&
// delivery_tel=0123456789&
// merchant_param1=additional+Info.&
// merchant_param2=additional+Info.&
// merchant_param3=additional+Info.&
// merchant_param4=additional+Info.&
// merchant_param5=additional+Info.&
// promo_code=&
// customer_identifier=
